export function schema_chatgpt() {
	return {
		title: "Paramètres",
		type: "object",
		required: ["column_result", "column_error", "column_request", "return_line", 'type', "content", "service", "model", "only_model_train", "messages", "element"],
		properties: {
			column_result: {
				type: "string",
				title: "Colonne de résultats",
				default: "result",
			},
			column_error: {
				type: "string",
				title: "Colonne de erreurs",
				default: "error",
			},
			column_request: {
				type: "string",
				title: "Colonne pour récupérer les requêtes avant envoi à ChatGPT",
				default: "request",
			},
			return_line: {
				type: "string",
				title: "Retour à la ligne",
				default: "<br />"
			},
			type: {
				type: "string",
				title: "Type, si pas de requêtes préparées",
				enum: ["requête", "messages"]
			},
			content: {
				type: "string",
				title: "Colonne des requêtes ou requête, si pas de requêtes préparées",
				format: "textarea"
			},
			service: {
				type: "string",
				title: "Service, si pas de requêtes préparées",
				enum: ["chatgpt", "perplexity"]
			},
			model: {
				type: "string",
				title: "Modèle, si pas de requêtes préparées"
			},
			only_model_train: {
				type: "boolean",
				format: "checkbox",
				title: "Si requêtes préparées, utiliser seulement le modèle"
			},
			messages: {
				options: {
					hidden: true,
				}
			},
			element: {
				options: {
					hidden: true,
				}
			},
			temperature: {
				title: "Température - de 0 à 2",
				type: "number",
				default: 1
			},
			top_p: {
				title: "top_p - de 0 à 1",
				type: "number",
				default: 1
			},
			column_document: {
				title: "Colonne des images",
				type: "string",
			},
			is_documents: {
				title: "Documents",
				type: "boolean",
				format: "checkbox"
			}
		},
	};
}
